module.exports = __webpack_public_path__ + "static/media/taeil-3.jpeg";